import {
    LayerType,
    type EditingRange,
    type ILayerProps,
    type ITextContent,
    type ITextLayerProps,
} from '@meitu/saas-editor-core/es/version-types';

type RichTextEditableProp = Extract<
    keyof ITextLayerProps,
    'fontFamily' | 'fontSize' | 'color' | 'bold' | 'italic' | 'underline' | 'lineThrough'
>;

export const getRichTextEditableProp = <T extends string | number | boolean>(
    textContents: ITextContent[] | undefined,
    range: EditingRange | null,
    prop: RichTextEditableProp,
    globalValue: T,
): T => {
    if (!range) {
        if (!textContents || textContents.length === 0) return globalValue;

        const values = textContents.map((item) => item[prop]);
        const set = new Set(values);

        return set.size === 1 ? (values[0] as T) : globalValue;
    }

    if (!textContents || textContents.length === 0) return globalValue;

    const { startIndex } = range;
    const values = textContents.map((item) => item[prop]);

    if (startIndex < values.length) return values[startIndex] as T;

    return globalValue;
};

// 递归返回第一个文本图层
export const findFirstTextLayer = (layer: ILayerProps | null): ILayerProps | null => {
    if (!layer) return null;

    if (layer.layerType === LayerType.TEXT_LAYER) {
        return layer;
    }

    if (layer.layerType === LayerType.GROUP_LAYER) {
        for (const child of layer.children) {
            const textLayer = findFirstTextLayer(child);
            if (textLayer) {
                return textLayer;
            }
        }
    }
    return null;
};
